import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [tenantBranding, setTenantBranding] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const session = JSON.parse(localStorage.getItem("session"));
    const storedToken =
      session?.token || localStorage.getItem("token");

    if (session?.user && storedToken) {
      setUser(session.user);
      setToken(storedToken);
      setTenantBranding(session.tenantBranding || null);
      setIsLoggedIn(true);
    }

    setIsLoading(false);
  }, []);

  const login = (
    userData,
    brandingData = null,
    authenticationToken
  ) => {
    setUser(userData);
    setToken(authenticationToken);
    setTenantBranding(brandingData);
    setIsLoggedIn(true);

    localStorage.setItem(
      "session",
      JSON.stringify({
        user: userData,
        token: authenticationToken,
        tenantBranding: brandingData,
      })
    );

    localStorage.removeItem("token");
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setTenantBranding(null);
    setIsLoggedIn(false);

    localStorage.removeItem("session");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        tenantBranding,
        isLoggedIn,
        isLoading,
        login,
        logout,
        setTenantBranding,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);